<app-report-header
  class="d-none d-print-block"
  [routeName]="route.name"
></app-report-header>

<app-report-summary
  class="d-none d-print-block mt-3"
  [route]="route"
></app-report-summary>

<h4 class="d-none d-print-block mt-3">Detail Report</h4>
<div [ngClass]="{ 'scroll-modal': !printView }">
  <table id="detail-report-table" class="table table-sm">
    <thead>
      <tr class="bg-gray-light">
        <th>State/Country</th>
        <th>Route</th>
        <th class="text-right">{{ distanceUnits | reportsDistanceUnit }}</th>
        <th class="text-right">Hours</th>
        <th>Interchange</th>
        <th class="text-right">
          Leg {{ distanceUnits | reportsDistanceUnit }}
        </th>
        <th class="text-right">Leg Hours</th>
        <th class="text-right">
          Total {{ distanceUnits | reportsDistanceUnit }}
        </th>
        <th class="text-right">Total Hours</th>
        <th class="text-right" *ngIf="hasTolls">Leg Tolls</th>
        <th *ngIf="hasTolls">Toll Plaza</th>
        <th *ngIf="hasEta">ETA/ETD</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let reportLine of detailReportReportLineView">
        <!-- Stop Row -->
        <ng-container *ngIf="reportLine.Stop !== null">
          <tr class="bg-gray-light font-weight-bold">
            <td colspan="2">
              <app-report-stop
                [stop]="reportLine.Stop"
                [routeColor]="route.color"
                [stopText]="reportLine.routeAddress"
              ></app-report-stop>
            </td>
            <td class="text-right">
              {{ reportLine.Miles | precision : precision }}
            </td>
            <td class="text-right">{{ reportLine.Time }}</td>
            <td>{{ reportLine.InterCh }}</td>
            <td class="text-right">
              {{ reportLine.LMiles | precision : precision }}
            </td>
            <td class="text-right">{{ reportLine.LTime }}</td>
            <td class="text-right">
              {{ reportLine.TMiles | precision : precision }}
            </td>
            <td class="text-right">{{ reportLine.TTime }}</td>
            <td class="white-space-nowrap text-right" *ngIf="hasTolls">
              {{
                !reportLine.TToll
                  ? ("0.00" | displayCurrency : displayCurrency)
                  : (reportLine.TToll | displayCurrency : displayCurrency)
              }}
            </td>
            <td *ngIf="hasTolls">{{ reportLine.TollPlazaAbbr }}</td>
            <td *ngIf="hasEta">{{ reportLine.EtaEtd }}</td>
          </tr>
        </ng-container>
        <!-- Warning Row -->
        <ng-container *ngIf="reportLine.Warn">
          <tr class="font-weight-bold text-danger">
            <td colspan="11">{{ reportLine.Warn }}</td>
          </tr>
        </ng-container>
        <!-- Arrival State Row -->
        <ng-container *ngIf="reportLine.ArState">
          <tr class="font-weight-bold">
            <td colspan="11">{{ reportLine.ArState }}</td>
          </tr>
        </ng-container>
        <!-- Normal Row -->
        <ng-container
          *ngIf="
            reportLine.Stop === null &&
            reportLine.Warn === null &&
            reportLine.ArState === null
          "
        >
          <tr>
            <td>{{ reportLine.State }}</td>
            <td>{{ reportLine.Route }}</td>
            <td class="text-right">
              {{ reportLine.Miles | precision : precision }}
            </td>
            <td class="text-right">{{ reportLine.Time }}</td>
            <td>{{ reportLine.InterCh }}</td>
            <td class="text-right">
              {{ reportLine.LMiles | precision : precision }}
            </td>
            <td class="text-right">{{ reportLine.LTime }}</td>
            <td class="text-right">
              {{ reportLine.TMiles | precision : precision }}
            </td>
            <td class="text-right">{{ reportLine.TTime }}</td>
            <td class="white-space-nowrap text-right" *ngIf="hasTolls">
              {{
                reportLine.LToll !== "0.00"
                  ? (reportLine.LToll | displayCurrency : displayCurrency)
                  : "--"
              }}
            </td>
            <td *ngIf="hasTolls">{{ reportLine.TollPlazaAbbr }}</td>
            <td *ngIf="hasEta">{{ reportLine.EtaEtd }}</td>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
  </table>
  <app-show-data-version [route]="route"></app-show-data-version>
</div>
